import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "../../data/site";

export const Products = () => (
    <section id="products" data-testid="products-section" className="bg-navy py-24 lg:py-32 relative overflow-hidden">
        <div className="absolute inset-0 blueprint-grid" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16 lg:mb-20">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                >
                    <p className="font-mono text-[11px] tracking-[0.35em] text-gold mb-6" data-testid="products-overline">
                        02 / PRODUCT LINES
                    </p>
                    <h2 className="font-heading font-extrabold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="products-heading">
                        EVERYTHING AN OFFICE NEEDS.<br />
                        <span className="text-outline-light">NOTHING IT DOESN'T.</span>
                    </h2>
                </motion.div>
                <motion.a
                    href="#contact"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                    className="group inline-flex w-fit items-center gap-2 px-7 py-4 bg-gold text-white font-medium tracking-wide hover:bg-white hover:text-navy transition-colors duration-300"
                    data-testid="products-quote-button"
                >
                    Get Bulk Pricing
                    <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </motion.a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4" data-testid="products-grid">
                {CATEGORIES.map((c, i) => (
                    <motion.a
                        key={c.id}
                        href="#contact"
                        initial={{ clipPath: "inset(100% 0 0 0)" }}
                        whileInView={{ clipPath: "inset(0% 0 0 0)" }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 1, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
                        className={`group relative overflow-hidden ${c.span} ${c.span === "lg:col-span-12" ? "h-[320px] md:h-[380px]" : "h-[380px] md:h-[440px]"}`}
                        data-testid={`product-card-${c.id}`}
                    >
                        <img
                            src={c.image}
                            alt={c.name}
                            loading="lazy"
                            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-navy/45 group-hover:bg-navy/25 transition-colors duration-500" />
                        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[radial-gradient(circle_at_50%_60%,rgba(184,134,11,0.28),transparent_65%)]" />

                        <div className="absolute top-5 left-5 font-mono text-[11px] tracking-[0.3em] text-white/80">
                            {c.num} /
                        </div>
                        <div className="absolute top-5 right-5 w-9 h-9 border border-white/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                            <ArrowUpRight size={15} className="text-white" />
                        </div>

                        <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8 bg-navy/85 backdrop-blur-sm">
                            <h3 className="font-heading font-bold tracking-tight text-white text-xl lg:text-2xl">
                                {c.name}
                            </h3>
                            <p className="mt-2 text-sm text-slate-300 leading-relaxed max-w-xl">{c.blurb}</p>
                            <div className="mt-4 flex flex-wrap gap-2">
                                {c.items.map((it) => (
                                    <span key={it} className="font-mono text-[10px] tracking-[0.15em] uppercase text-gold border border-gold/40 px-2.5 py-1">
                                        {it}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </motion.a>
                ))}
            </div>
        </div>
    </section>
);
